import React from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { icon, IconComponent } from "../../icon-component";
import { CustomIconButton } from "../../buttons";
import styles from "./AlertBanner.module.css";

type SvgIconComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;
type IconSource = IconProp | SvgIconComponent;
interface AlertBannerProps {
	actions?: React.ReactNode;
	className?: string;
	iconClassName?: string;
	iconElement?: IconSource;
	iconSpin?: boolean;
	description: string;
	onClose?: () => void;
	title: string;
	variant?: "info" | "warning" | "error" | "success";
}
const iconColors: Record<NonNullable<AlertBannerProps["variant"]>, string> = {
	info: "var(--status-info-icon)",
	warning: "var(--status-warning-icon)",
	error: "var(--status-error-icon)",
	success: "var(--status-success-icon)",
};
const icons: Record<NonNullable<AlertBannerProps["variant"]>, IconSource> = {
	info: icon.faInfoCircle,
	warning: icon.faExclamationTriangle,
	error: icon.faTimesCircle,
	success: icon.faCheckCircle,
};
const AlertBanner = React.forwardRef<HTMLDivElement, AlertBannerProps>(
	(
		{
			actions,
			className,
			iconClassName = "",
			iconElement = undefined,
			iconSpin = false,
			description,
			onClose,
			title,
			variant = "info",
		},
		ref
	) => (
		<div ref={ref} className={`${styles.container} ${className}`} data-variant={variant}>
			<div className={styles.leftSideContent}>
				<div className={styles.iconContainer}>
					<IconComponent
						className={iconClassName}
						color={iconColors[variant || "info"]}
						icon={iconElement || icons[variant || "info"]}
						size="sm"
						spin={iconSpin}
					/>
				</div>
				<div>
					<div className={styles.title}>{title}</div>
					<div className={styles.description}>{description} </div>
				</div>
			</div>
			<div className={styles.rightSideContent}>
				{actions}
				{typeof onClose === "function" && <CustomIconButton icon={icon.faTimes} size="xs" onClick={onClose} />}
			</div>
		</div>
	)
);

export default AlertBanner;
